import { parseQuery, stringifyQuery } from '@/utils/URLUtils';
import { createBrowserHistory } from 'history';
import _ from 'lodash';

export type LocationActionType = 'PUSH' | 'REPLACE';
export const LocationAction = {
  push: 'PUSH',
  replace: 'REPLACE',
};
const PUBLIC_PATH = process.env.PUBLIC_PATH || '';
const history = createBrowserHistory({ basename: PUBLIC_PATH });

export interface UpdateLocationParams {
  query?: Record<string, any>;
  type?: LocationActionType;
  pathname?: string;
}

export function getPathname(pathname) {
  return PUBLIC_PATH ? `${PUBLIC_PATH}${pathname}` : pathname;
}

function navigate(type: LocationActionType, path: any, state?: any) {
  const forward = type === LocationAction.replace ? history.replace : history.push;
  if (_.isString(path)) {
    forward(path, state);
  }

  if (_.isObject(path)) {
    const { pathname, query: queryObject, ...params }: any = path;
    forward({
      pathname,
      search: stringifyQuery(queryObject),
      ...params,
    });
  }
}

export function push(path: string | Record<string, unknown>, state?: any) {
  navigate(LocationAction.push as LocationActionType, path, state);
}

export function replace(path: string | Record<string, unknown>, state?: any) {
  navigate(LocationAction.replace as LocationActionType, path, state);
}

export function removeQuery(query: string[]) {
  const { pathname, search } = history.location;
  const queryObject = parseQuery(search);
  const newQueryObject = _.omit(queryObject, query);
  replace({
    pathname,
    query: newQueryObject,
  });
}

export function goBack() {
  history.goBack();
}

/**
 * 更新路由，支持合并原有的 queryString
 * @param params
 */
export function updateLocation(params: UpdateLocationParams) {
  /**
   * 这里的 pathname 不能使用 window.location.pathname 作为默认值
   * 否则在 path 模式下，会出现重复的 path
   */
  const { query, type = LocationAction.push, pathname } = params;
  if (_.isNil(pathname)) {
    throw Error('pathname should not be empty');
  }
  const navigate = type === LocationAction.push ? push : replace;
  const defaultQuery = parseQuery(window.location.search);
  navigate({
    pathname,
    query: { ...defaultQuery, ...query },
  });
}
export default history;
